import React from "react";
import { Loader } from "../Loader/Loader";
import { Box } from "@mui/material";
import Styles from "./CommonLoader.module.scss";
const CommonLoader = ({ openLoader }) => {
  return (
    <Box
      className={Styles.loaderContainer}
      sx={{ display: openLoader ? "flex" : "none" }}
    >
      <Loader color="#00675d" />
    </Box>
  );
};

export default CommonLoader;
